@import 'styles/mixins';
@import 'styles/blaze/mixins';

.counter {
  @include sm-sohne;
  line-height: 14.9px;
  background: var(--dark-4);
  border-radius: 12px;
  color: var(--dark-80);
  padding: 6px;
  width: fit-content;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
}

.xs {
  @include xs-sohne-medium;
  padding: 4px;
  height: 16px;

  &.oneDigit:not(.withLabel) {
    width: 16px;
    line-height: 18px;
  }
}

.sm {
  @include sm-regular;
  padding: 2px 6px;
}

.secondary {
  color: var(--light-100);
  background: var(--light-7);
}

.tertiary {
  color: var(--light-100);
  background: var(--selected-fill);
}

.dark {
  color: var(--light-100);
  background: var(--dark-80);
}

.light {
  color: var(--dark-100);
  background: var(--light-80);
}

.max {
  padding-right: 4px;
}

.plusIcon {
  margin-top: -1px;
}

.withBorder {
  border: 1px solid var(--light-100);
}

.label {
  margin-left: 4px;
}

.oneDigit:not(.withLabel) {
  width: 20px;
}
